import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Header } from "../header";
import { Footer } from "../footer";
import { axiosAuth } from "../../../utils/axiosInstance";
import { getInitials } from "./userAccountUtils";
import "../../../css/userAccount.css";

const NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    path: "/dashboard",
    icon: "fa-gauge-high",
  },
  {
    id: "bookings",
    label: "My Bookings",
    path: "/booking",
    icon: "fa-calendar-check",
  },
  { id: "profile", label: "Profile", path: "/profile", icon: "fa-user" },
  {
    id: "book",
    label: "Book a Court",
    path: "/all-facilities",
    icon: "fa-plus",
    accent: true,
  },
];

const UserAccountLayout = ({
  active,
  title,
  subtitle,
  children,
  actions,
}) => {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchUser = async () => {
      try {
        const response = await axiosAuth.get("get-user-details");
        if (!cancelled && response.status === 200 && response.data?.user) {
          setUser(response.data.user);
        }
      } catch (error) {
        if (!cancelled) console.error("Error fetching user:", error);
      }
    };

    fetchUser();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  const displayName = user?.name?.trim() || "User";
  const displayEmail = user?.email || user?.contact || user?.phone || "";
  const avatarSrc = user?.image
    ? user.image.startsWith("http")
      ? user.image
      : `${process.env.REACT_APP_IMG_URL}${user.image}`
    : null;

  return (
    <>
      <Header />
      <div className="ua-page">
        <div className="ua-shell bv-container bv-container--wide">
          <aside className="ua-sidebar" aria-label="Account navigation">
            <div className="ua-sidebar__profile">
              <span className="ua-sidebar__avatar" aria-hidden="true">
                {avatarSrc ? (
                  <img src={avatarSrc} alt="" />
                ) : (
                  <span>{getInitials(displayName)}</span>
                )}
              </span>
              <div className="ua-sidebar__meta">
                <strong>{displayName}</strong>
                {displayEmail ? <span>{displayEmail}</span> : null}
              </div>
            </div>

            <nav className="ua-nav">
              {NAV_ITEMS.map((item) => {
                const isActive = active === item.id;
                return (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={`ua-nav__link ${
                      isActive ? "is-active" : ""
                    } ${item.accent ? "ua-nav__link--accent" : ""}`}
                    aria-current={isActive ? "page" : undefined}
                  >
                    <i className={`fa-solid ${item.icon}`} aria-hidden="true" />
                    <span>{item.label}</span>
                    {isActive ? (
                      <i
                        className="fa-solid fa-chevron-right ua-nav__chevron"
                        aria-hidden="true"
                      />
                    ) : null}
                  </Link>
                );
              })}
            </nav>
          </aside>

          <main className="ua-main">
            <header className="ua-main__head">
              <div className="ua-main__titles">
                <h1>{title}</h1>
                {subtitle ? <p>{subtitle}</p> : null}
              </div>
              {actions ? (
                <div className="ua-main__actions">{actions}</div>
              ) : null}
            </header>
            <div className="ua-main__body">{children}</div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserAccountLayout;
